import MuiTabContext from '@mui/lab/TabContext';
import MuiTabList from '@mui/lab/TabList';
import Box from '@mui/material/Box';
import MuiTab from '@mui/material/Tab';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const Tabs = ({ children, tabs, value, onChange, sx, ...props }) => {
  const theme = useTheme();
  const handleChange = (event, newValue) => {
    onChange && onChange(newValue);
  };

  return (
    <MuiTabContext value={value}>
      <Box sx={[{ boxShadow: `inset 0px -1px ${theme.palette.divider}` }, sx]}>
        <MuiTabList onChange={handleChange} {...props}>
          {tabs.map(({ label, value, ...rest }, idx) => (
            <MuiTab
              key={value ?? idx}
              label={label}
              value={value}
              iconPosition="start"
              {...rest}
            />
          ))}
        </MuiTabList>
      </Box>
      {children}
    </MuiTabContext>
  );
};

Tabs.propTypes = {
  children: PropTypes.node,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Tabs;
